export default __webpack_public_path__ + "static/media/grinning-pepe.e6177da3.jpeg";